import { render } from "./FCalendar.vue?vue&type=template&id=0fc5fb32"
import script from "./FCalendar.vue?vue&type=script&lang=js"
export * from "./FCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__